<script lang="ts">
  // Selbstcheck-Warnung (Schicht 4 der Benachrichtigungs-Überwachung,
  // portiert aus home-dash): der Push-Kanal kann sich nicht selbst
  // melden -> hier in-app, wenn auf DIESEM Gerät vermutlich keine
  // Benachrichtigungen ankommen. "Neu einrichten" macht den vollen
  // Re-Subscribe (pwaResubscribe); Fehler dabei werden IM Banner
  // gezeigt statt still zu verpuffen. Sitzungslokal wegklickbar.
  import { t } from "./i18n.svelte";
  import Kreuz from "./Kreuz.svelte";
  import { pushSelf, pwaResubscribe } from "./pwa.svelte";

  let dismissed = $state(false);
  const show = $derived(pushSelf.loaded && pushSelf.problem && !dismissed);
</script>

{#if show}
  <div
    class="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
  >
    <div
      class="border-warning/40 bg-bg/95 pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-xl border px-4 py-2.5 shadow-2xl backdrop-blur"
      role="status"
    >
      <div class="text-fg min-w-0 flex-1 text-sm">
        {t(
          "push.health.warn",
          "Auf diesem Gerät kommen Benachrichtigungen gerade vermutlich nicht an",
        )}
        {pushSelf.deliver === "unknown"
          ? t("push.health.warn_unknown", "(Abo nicht mehr bekannt)")
          : ""}. {t("push.health.warn_cta", "Neu einrichten?")}
        {#if pushSelf.error}
          <span class="text-warning mt-1 block text-xs">{pushSelf.error}</span>
        {/if}
      </div>
      <button
        type="button"
        onclick={() => void pwaResubscribe()}
        disabled={pushSelf.busy}
        class="bg-accent/15 text-accent border-accent/30 shrink-0 rounded-md border ctrl-m text-xs font-medium transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {pushSelf.busy ? "…" : t("push.health.resetup", "Neu einrichten")}
      </button>
      <button
        type="button"
        onclick={() => (dismissed = true)}
        class="text-fg-subtle hover:text-fg shrink-0 rounded p-1 text-lg leading-none transition"
        aria-label={t("push.health.dismiss", "Hinweis ausblenden")}
      >
        <Kreuz />
      </button>
    </div>
  </div>
{/if}
